import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.layout ? 'column' : 'row')};
  margin: 0 7px;
  flex: 1;
  height: ${(props) => (props.layout ? 'auto' : '100%')};
`;

export const TopContent = styled.div`
  background: white;
  border-radius: 4px;
  margin-bottom: 8px;
  flex-shrink: 0;
`;

export const NavigationRow = styled.div`
  border-radius: 4px 0 0 0;
  overflow: hidden;
`;

export const MetricsPanelWrapper = styled.div`
  width: 380px;
  margin-right: 2px;
  height: 100%;
  margin-bottom: 0px;
`;

export const HzMetricsPanelWrapper = styled.div`
  width: 100%;
  margin-right: 2px;
  margin-bottom: 5px;
`;

export const DimensionPanelWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 2px;
  min-height: 600px;
  &:hover {
    overflow-y: auto;
    overflow-x: hidden;
  }
`;
